import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { TransformCta } from './CtaButton';
export function Bonuses() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-51" data-mp="plsilzwt0s74">
      <div className="mx-auto max-w-4xl" data-id="element-52" data-mp="aujww1w0vqz9">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-white sm:text-4xl" data-id="element-53" data-mp="ftwkwpymr43f">
          🎁 Además recibirás estos 5 Bonos Exclusivos
        </h2>
        <p className="mt-3 text-center text-[14px] font-semibold text-white/70 sm:text-lg" data-id="element-54" data-mp="1wrjx4drwvf1">
          Valorados en <span className="text-gold-400" data-id="element-55" data-mp="5tnnx9wtdemz">USD 140</span>
        </p>
        <p className="mt-1 text-center text-[13px] font-extrabold uppercase tracking-wide text-gold-400 sm:text-base" data-id="element-56" data-mp="3o369yhbo54hb">
          Hoy incluidos completamente GRATIS
        </p>

        <div className="mt-9 space-y-5" data-id="element-57" data-mp="1mba0recz46pp">
          {bonos.map(bono => <article key={bono.numero} className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.05]" data-id="element-58" data-mp="1r9v0lcobcodm">
              {bono.imagen && <img src={bono.imagen} alt={`Mockup del bono ${bono.nombre}`} className="w-full bg-white" loading="lazy" data-id="element-59" data-mp="3dflihk627m8a" />}
              <div className="p-5 sm:p-7" data-id="element-60" data-mp="3n67pwr3mh6fw">
                <span className="inline-block rounded-full bg-gold-500 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-navy-950 sm:text-xs" data-id="element-61" data-mp="3n7is4mhf664w">
                  🎁 {bono.numero}
                </span>
                <h3 className="mt-3 font-display text-xl font-black leading-tight text-white sm:text-2xl" data-id="element-62" data-mp="38g0gt1zi8zrv">
                  {bono.nombre}
                </h3>
                <p className="mt-2 text-[14px] font-semibold leading-snug text-violet-400 sm:text-[16px]" data-id="element-63" data-mp="33fujb56k0j1v">
                  {bono.promesa}
                </p>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-white/70 sm:text-[15px]" data-id="element-64" data-mp="irq1qpjjuuaq">
                  {bono.texto}
                </p>

                {bono.bullets && <ul className="mt-3 space-y-1.5" data-id="element-65" data-mp="3hhhsksg06996">
                    {bono.bullets.map(b => <li key={b} className="flex items-start gap-2" data-id="element-66" data-mp="3lj32q615k9fo">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-67" data-mp="3lhs049jg17q5" />
                        <span className="text-[13px] text-white/80 sm:text-[14.5px]" data-id="element-68" data-mp="2tqc27jcfrykm">{b}</span>
                      </li>)}
                  </ul>}

                <div className="mt-4 flex flex-wrap items-center gap-2" data-id="element-69" data-mp="32rk1o4qov5ga">
                  <span className="rounded-lg bg-white/10 px-2.5 py-1 text-[12px] font-medium text-white/60 line-through sm:text-sm" data-id="element-70" data-mp="37kv8w6zexo8q">
                    Valor: {bono.valor}
                  </span>
                  <span className="rounded-lg bg-emerald-500 px-2.5 py-1 text-[12px] font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-71" data-mp="2f2h7jxevbk4w">
                    Hoy: Gratis
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <TransformCta tone="dark" headline="Llévate los 6 tomos + los 5 bonos por un pago único." data-id="element-72" data-mp="1xl28ckxty5rc" />
      </div>
    </section>;
}